import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'
import {LinkIcon} from '@primer/octicons-react'
import type React from 'react'

import {ListSidebar, ListSidebarCollapsedButton} from '../shared/ListSidebar'
import type {TypeFilter} from '../types/repos-list-types'
import {getQueryFromType, iconClassByType, Sidebar, SidebarCollapsedButton} from './Sidebar'

export function OrgSidebar({onQueryChanged, type, types}: React.ComponentProps<typeof Sidebar>) {
  if (useFeatureFlag('repos_list_new_sidebar')) {
    return <ListSidebar links={getOrgLinks(types)} selectedLink={type} onQueryChanged={onQueryChanged} />
  }

  return <Sidebar onQueryChanged={onQueryChanged} type={type} types={types} />
}

export function OrgSidebarCollapsedButton(props: React.ComponentProps<typeof SidebarCollapsedButton>) {
  if (useFeatureFlag('repos_list_new_sidebar')) {
    return (
      <ListSidebarCollapsedButton
        links={getOrgLinks(props.types)}
        selectedLink={props.type}
        onQueryChanged={props.onQueryChanged}
      />
    )
  }

  return <SidebarCollapsedButton {...props} />
}

function getOrgLinks(types: TypeFilter[]) {
  return types.map(({id, text}) => ({
    id,
    query: getQueryFromType(id),
    text,
    title: `${text} repositories`,
    IconComponent: iconClassByType[id] || LinkIcon,
  }))
}

try{ OrgSidebar.displayName ||= 'OrgSidebar' } catch {}
try{ OrgSidebarCollapsedButton.displayName ||= 'OrgSidebarCollapsedButton' } catch {}